<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="kbTit">
			<div class="kbTLeft">
				<div class="kbFanh" @click="fhKeben">
					<i class="el-icon-arrow-left"></i>
					返回错题分布
				</div>
				<div class="kbFBtns">
					<div class="kbFBtn" @click="btns('up')" :class="fFlag == 0 ? 'active' : ''">
						上一段材料
						<i class="el-icon-caret-top"></i>
					</div>
					<div class="kbFBtn" @click="btns('down')" :class="fFlag == examArrData.length - 1 ? 'active' : ''">
						下一段材料
						<i class="el-icon-caret-bottom"></i>
					</div>
				</div>
			</div>
			<div class="kbTj">课时/材料数 {{ perData.number?.match(/T(\d+)W/)[1] }}</div>
		</div>
		<div class="kbCont">
			<div class="kaoshiCont">
				<div class="kaoshiFixYs">
					<div class="kaoshiFixYsCont">
						{{ bsData.slice(bsIns, bsIns + 1)[0] + 'x' }}
					</div>
					<div class="kaoshiFixP">
						<img src="@/assets/img/x.png" @click="yusFn('-')" class="img1" alt="" />
						<p>语速调节</p>
						<img src="@/assets/img/s.svg" @click="yusFn('+')" class="img2" alt="" />
					</div>
				</div>
				<div class="kaoshiTm">
					<div class="kaoshiTmFbts">试题编号：{{ perData.number }}</div>
					<div class="kaoshiTmFbt">
						听材料回答以下{{ thData?.split(',')[perData.yydSmallQuestionList.length - 1] }}小题
						<!-- <div class="kaoshiWtBtn" @click="jtBtns(perData)">
                <img v-if="ftFlag==1" src="@/assets/img/形状.png" alt="">
                精听
              </div> -->
						<jting-button @btns="jtBtns(perData)" @qkFn="qkFn" :ref="'jting'" />
					</div>
					<div class="kaoshiT" :class="{ cwActive: item.cw }" v-for="(item, index) in perData.yydSmallQuestionList" :key="index">
						<div class="kaoshiWt">
							<div class="kaoshiDa">
								<i>(</i>
								<span>{{ item.d }}</span>
								<i>)</i>
							</div>
							<div class="tips">{{ index + 1 }}、{{ item.title }}</div>
						</div>
						<div class="kaoshiXx">
							<p :class="{ active: item.d == i.number }" v-for="(i, s) in item.yydSmallQuestionOptionList" @click="item.d = i.number" :key="s">
								{{ i.number }} 、{{ i.content }}
							</p>
						</div>
					</div>
				</div>
				<div class="lookJx" @click="jxFlag = !jxFlag">
					查看解析
					<i class="el-icon-caret-bottom" v-if="!jxFlag"></i>
					<i class="el-icon-caret-top" v-if="jxFlag"></i>
				</div>
				<div class="lookDaBox" v-show="jxFlag">
					<div class="lookDaTit">正确答案：{{ names }}</div>
					<div class="lookDaCont">
						<p v-html="perData.originalContent"></p>
					</div>
					<div class="lookDaBtn" @click="tltBtn()">加入错题本</div>
				</div>
				<ctHz :tableData="tableData" />
			</div>
		</div>
	</div>
</template>

<script>
import ctHz from '@/components/pubComponents/ctHz.vue';
import axios from 'axios';

export default {
	name: 'cuotiJlu',
	data() {
		return {
			fxFlag: false,
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			bsIns: 2,
			fullscreenLoading: false,
			upFlag: true,
			downFlag: true,
			jxFlag: false,
			tableData: [],
			eindexData: {},
			fFlag: 0,
			aurl: '',
			perData: {
				yydSmallQuestionList: []
			},
			ftFlag: 1,
			thData: '一,二,三,四,五,六,七,八,九,十,十一,十二,十三,十四,十五,十六,十七,十八,十九,二十,二十一,二十二,二十三,二十四,二十五,二十六,二十七,二十八,二十九,三十'
		};
	},
	components: {
		ctHz
	},
	computed: {
		names() {
			let str = '';
			this.perData.yydSmallQuestionList.forEach((item, index) => {
				str += `${index + 1}、${item.answer || ''} `;
			});
			return str;
		}
	},
	props: ['examData', 'bjId', 'userTextbookId', 'examArrData'],
	methods: {
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		jtBtns(item) {
			console.log(item.recordingFileId, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => {});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		tlBtn() {
			if (this.ftFlag == 1) {
				if (this.perData.recordingFileId) {
					this.ftFlag = 2;
				} else {
					this.ftFlag = 3;
				}
			}
		},
		fhKeben() {
			this.$emit('fhBtns', 'cuotiFb', 'keben');
		},
		fxFn() {
			this.fxFlag = true;
		},
		btns(type) {
			console.log(7777);
			this.qkFn();
			if (type == 'up') {
				if (this.fFlag == 0) {
					return;
				}
				this.fFlag--;
				this.eindexData = this.examArrData[this.fFlag];
				this.init();
			} else {
				if (this.fFlag == this.examArrData.length - 1) {
					return;
				}
				this.fFlag++;
				this.eindexData = this.examArrData[this.fFlag];
				this.init();
			}
		},
		init() {
			console.log(this.eindexData.id, this.examArrData, this.userTextbookId, 777);
			this.fullscreenLoading = true;
			this.$http
				.post(`api/app/yydAnswerQuestion/wrongQuestionDistribution/${this.eindexData.id}`, {
					bjId: this.bjId,
					bjExamId: this.userTextbookId,
					type: 0
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res, 2222);
						let arr = [];
						let str = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八'];
						res.data?.forEach((item, index) => {
							arr.push({
								tNum: str[index],
								xuanx: 'A',
								fenbmd: item.answer == 'A' ? '正确' : item.astudent || '',
								hej: `${item.anumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'B',
								fenbmd: item.answer == 'B' ? '正确' : item.bstudent || '',
								hej: `${item.bnumber}人`
							});
							arr.push({
								tNum: str[index],
								xuanx: 'C',
								fenbmd: item.answer == 'C' ? '正确' : item.cstudent || '',
								hej: `${item.cnumber}人`
							});
						});
						this.tableData = arr;
					}
				});
			this.$http.get(`api/app/yydExaminationQuestion/examQuestionListDetail/${this.eindexData.id}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					console.log(res, 44444);
					res.data.yydSmallQuestionList = res.data.yydSmallQuestionList.map((item) => {
						return {
							...item,
							jxFlag: false,
							d: ''
						};
					});
					this.perData = res.data || {};
					// this.$xzFn({
					//   fileId: this.perData.recordingFileId,
					//   token: localStorage.getItem('token'),
					//   type:1,
					// },res=> {
					//   const blob = new Blob([res], { type:'audio/mpeg'});
					//   const url = URL.createObjectURL(blob);
					//   console.log(url,55555555554444)
					//   this.aurl = url
					//   // this.$audio.play(url);
					// })
				}
			});
		},
		tltBtn() {
			let set = this.$loading(this.$pre);
			this.$http.post(`api/app/yydErrorEdition/${this.eindexData.id}/1`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.$message({
						type: 'success',
						message: '加入成功'
					});
				}
			});
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
			this.$audio.playbackRate(this.bsData.slice(this.bsIns, this.bsIns + 1)[0]);
		},
		txtFn() {
			console.log(this.examData, 7777);
			this.examArrData.forEach((item, index) => {
				if (item.id == this.eindexData.id) {
					this.fFlag = index;
				}
			});
		}
	},
	mounted() {
		this.eindexData = this.examData;
		this.txtFn();
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.kbBox {
	.kbTit {
		height: 80px;
		border-bottom: 1px solid #eeeff2;
		display: flex;
		align-items: center;
		padding: 0 26px 0 16px;
		justify-content: space-between;
		> div {
			display: flex;
			align-items: center;
			font-size: 14px;
			cursor: pointer;
			color: #000000;
			line-height: 1;
			img {
				width: 22px;
				height: 22px;
				margin-right: 4px;
			}
			i {
				margin-right: 4px;
				font-size: 16px;
			}
		}
		.kbTLeft {
			.kbFBtns {
				margin-left: 45px;
				display: flex;
				font-size: 14px;
				color: #3d3d3d;
				.kbFBtn {
					display: flex;
					align-items: center;
					margin-right: 32px;
					font-size: 14px;
					i {
						margin-left: 4px;
					}
				}
				.active {
					color: #b2b1b1;
					cursor: no-drop;
				}
			}
		}
	}
}
.dfIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #1d7b3a;
	font-size: 14px;
	img {
		margin-right: 4px;
		width: 14px;
		height: 14px;
	}
}
.dfIcon1 {
	color: #fa4a1b;
}
.tjBoxs {
	display: flex;
}
.kbCont {
	padding: 17px 28px;
	position: relative;
}
.kaoshiCont {
	color: #000000;
	h1 {
		font-size: 28px;
		padding-top: 38px;
		margin-bottom: 25px;
		font-weight: bold;
		text-align: center;
	}
	h2 {
		font-size: 18px;
		margin-bottom: 27px;
		text-align: center;
		padding-bottom: 34px;
		border-bottom: 1px solid #f8f8f8;
	}
	.kaoshiTm {
		.kaoshiTmFbts {
			font-size: 14px;
			color: #3d3d3d;
			margin-bottom: 15px;
		}
		.kaoshiTmFbt {
			font-size: 18px;
			color: #3d3d3d;
			display: flex;
			align-items: center;
			margin-bottom: 34px;
			.kaoshiWtBtn {
				margin-left: 19px;
				padding: 0 10px;
				height: 26px;
				background: #1d7b3a;
				border-radius: 4px;
				color: #fff;
				font-size: 14px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-weight: 400;
				cursor: pointer;
				img {
					width: 16px;
					height: 14px;
					margin-right: 6px;
				}
			}
		}
		h3 {
			font-size: 18px;
			font-weight: bold;
			margin: 40px 0 13px;
			text-indent: 2em;
		}
		> p {
			font-size: 16px;
			line-height: 2;
			text-indent: 2em;
			margin-bottom: 38px;
		}
		h4 {
			font-weight: bold;
			font-size: 18px;
			margin: 40px 0;
		}
		.kaoshiT {
			margin-bottom: 40px;
			&:last-of-type {
				margin-bottom: 0;
			}

			.kaoshiXx {
				padding-left: 102px;

				p {
					margin-bottom: 36px;
					font-size: 18px;
					cursor: pointer;

					&:last-of-type {
						margin-bottom: 0;
					}
				}
				.active {
					color: #1d7b3a;
				}
			}
			.kaoshiWt {
				display: flex;
				font-weight: bold;
				margin-bottom: 36px;

				.kaoshiDa {
					width: 72px;
					margin-right: 30px;
					position: relative;
					display: flex;
					justify-content: space-between;
					span {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						line-height: 1;
						margin-top: 2px;
					}
				}
			}
		}
	}
}
.kaoshiFixYs {
	position: absolute;
	top: 22px;
	right: 7px;
	width: 108px;
	height: 98px;
	color: #fff;
	background: url('@/assets/img/ys.svg') 100% no-repeat;
	.kaoshiFixYsCont {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin-top: -4px;
	}
	.kaoshiFixP {
		position: absolute;
		bottom: 15px;
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
		align-items: center;
		p {
			margin: 0 6px;
		}
		img {
			width: 9px;
			height: 6px;
			cursor: pointer;
			margin-top: 1px;
		}
		.img1 {
			transform: rotate(90deg);
		}
		.img2 {
			transform: rotate(90deg);
		}
	}
}
.lookJx {
	color: #1d7b3a;
	cursor: pointer;
	margin: 30px 0 20px 31px;
}
.lookDaBox {
	margin-left: 31px;
	.lookDaTit {
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 16px;
	}
	.lookDaCont {
		margin-bottom: 20px;
		line-height: 2;
		font-size: 16px;
		color: #000000;
		span {
			color: #1d7b3a;
		}
	}
	.lookDaBtn {
		width: 88px;
		height: 40px;
		border: 1px solid #1d7b3a;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		color: #1d7b3a;
		cursor: pointer;
		border-radius: 6px;
	}
}
</style>
